"use strict";const s=require("styled-components").createGlobalStyle`
html {
    -moz-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
}

@font-face {
    font-family: "Gilroy";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-ExtraBold.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-ExtraBold.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-ExtraBold.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-ExtraBold.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-ExtraBold.ttf")
            format("truetype");
    font-weight: 800;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "Gilroy";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-Bold.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-Bold.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-Bold.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-Bold.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-Bold.ttf")
            format("truetype");
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "Gilroy";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-SemiBold.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-SemiBold.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-SemiBold.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-SemiBold.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-SemiBold.ttf")
            format("truetype");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "Gilroy";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-Medium.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-Medium.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-Medium.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-Medium.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/Gilroy-Medium.ttf")
            format("truetype");
    font-weight: 200;
    font-style: normal;
    font-display: swap;
}
`;exports.FontStyle=s;
//# sourceMappingURL=Fonts.js.map
